import { render, staticRenderFns } from "./TypeList.vue?vue&type=template&id=4b2746d3&scoped=true&"
import script from "./TypeList.vue?vue&type=script&lang=js&"
export * from "./TypeList.vue?vue&type=script&lang=js&"
import style0 from "./TypeList.vue?vue&type=style&index=0&id=4b2746d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2746d3",
  null
  
)

export default component.exports